import { createStore } from '@stencil/store';

import { AnswerVehicle } from '../interfaces/interface.vehicle';
import { getFromBrowserStorage, removeFromBrowserStorage, setFromBrowserStorage, writeStoreToBrowserStorage } from '../utils/utils.store';
import { baseVehicleState } from '../utils/utils.vehicle';

import { initialState as customerState } from './store.customer';
import { state as dealerState } from './store.dealer';

const answerVehicleInitialState: AnswerVehicle = {
  ...baseVehicleState,
  apiSelectedOptionIds: [],
  apiUnselectedOptionIds: [],
  cadsUsed: false, // build data flag
  transmissionsVinVerified: false, // build data flag
  enginesVinVerified: false, // build data flag
  drivetrainsVinVerified: false, // build data flag
  optionsVinVerified: false, // build data flag
  colorsVinVerified: false, // build data flag
  vinVerified: false,
  isValid: false,
  // TODO this should go away once we build the vehicle equipment component and ask this directly as a question
  hasTwoSetsOfKeys: false,
  invalidEngine: false,
  invalidTransmission: false,
  invalidDrivetrains: false,
  invalidColor: false,
  selectedOptionsState: [],
};

// Conditions answers:
// Passive (mostly, conditions answers the exception) follower store to provide payload for
// endpoint used for offer submission.
// Not intended for usage other than providing payload
// data for the offer submission.
// Not recommended for usage in a hydrator.
const initialState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  conditions: [] as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history: [] as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replacementVehicle: [] as any,
  // We're using the customerState initialState, but nothing else.
  // The customerState isn't set by the questions, the answers are set directly on the answer store.
  // So there's no need to set up a onCustomerChange handler, since no changes happen to customerState
  contactInfo: {
    ...customerState,
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  other: [] as any,
  vehicle: {
    ...answerVehicleInitialState, // sync from source
  },
  dealerInfo: {
    ...dealerState,
  },
  captcha: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: '' as any,
    captchaReady: false,
  },
  pixall: {
    includePixall: false,
  },
  isConsumerOffer: true,
  disposalOptions: {
    isKelleyBuysYourCar: false,
    isInstantCashOffer: true,
    isKelleyBuysYourCarFakeDoor: false,
  },
};

let isInitalized = false;

const { state, on, onChange, reset } = createStore(initialState);

const storeName = 'store.answers';

on('set', () => {
  if (isInitalized) {
    writeStoreToBrowserStorage(state, storeName);
  }
});

export const populateFromLocal = () => {
  setFromBrowserStorage(storeName, state);
};

export const getFromLocal = () => {
  return getFromBrowserStorage(storeName);
};

export const setInitialized = (initializedValue: boolean) => {
  isInitalized = initializedValue;
};

export const clearFromLocal = () => {
  setInitialized(false);
  removeFromBrowserStorage(storeName);
};

export { on, onChange, state, reset };
export default state;
